import { render, staticRenderFns } from "./DatatableHeaderItem.vue?vue&type=template&id=12f30e7d&"
import script from "./DatatableHeaderItem.vue?vue&type=script&lang=js&"
export * from "./DatatableHeaderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports